import React from "react";

const Loader = ({ height = "300px", size = "3rem", color = "#09558f" }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: height }}
    >
      <div
        className="spinner-border"
        role="status"
        style={{
          width: size,
          height: size,
          color,
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
